import { createSelector } from 'reselect';

const selectShipxAgencyMappings = (state: any) => state.shipxAgencyMappings;


export const selectShipxMappingCurrentItem = createSelector([selectShipxAgencyMappings], (shipxAgencyMappings) => shipxAgencyMappings.current);

export const selectShipxMappingListItems = createSelector([selectShipxAgencyMappings], (shipxAgencyMappings) => shipxAgencyMappings.list);

export const selectShipxMappingItemById = (itemId: any) =>
    createSelector(selectShipxMappingListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectShipxMappingQueryItems = createSelector([selectShipxAgencyMappings], (shipxAgencyMappings) => shipxAgencyMappings.query);

export const selectShipxMappingCreatedItem = createSelector([selectShipxAgencyMappings], (shipxAgencyMappings) => shipxAgencyMappings.create);

export const selectShipxMappingUpdatedItem = createSelector([selectShipxAgencyMappings], (shipxAgencyMappings) => shipxAgencyMappings.update);

export const selectShipxMappingReadItem = createSelector([selectShipxAgencyMappings], (shipxAgencyMappings) => shipxAgencyMappings.read);

export const selectShipxMappingDeletedItem = createSelector([selectShipxAgencyMappings], (shipxAgencyMappings) => shipxAgencyMappings.delete);

export const selectShipxAgencyMappingsearchedItems = createSelector([selectShipxAgencyMappings], (shipxAgencyMappings) => shipxAgencyMappings.search);

export const selectShipxMappingItemsCount = createSelector([selectShipxAgencyMappings], (shipxAgencyMappings) => shipxAgencyMappings.count);

export const selectShipxMappingItemsFilter = createSelector([selectShipxAgencyMappings], (shipxAgencyMappings) => shipxAgencyMappings.filter);